<template>
  <b-form>
    <b-col>
      <h1>{{ $t('privatePage.testmethod_order_header') }}</h1>
      <draggable v-model="currentTestMethod.testMethodQuestions" item-key="question['id']">
        <template #item="{element, index}">
          <div>
            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button v-if="element.orderNumber === -1" style="text-align: left; padding-left: 20px;" block href="#" v-b-toggle="'accordion' + index" variant="danger">
                  {{getQuestionName(element.question, index)}}
                  <b-badge pill variant="dark">{{ $t('privatePage.testmethod_unsorted_warning') }}</b-badge>
                </b-button>
                <b-button v-else style="text-align: left; padding-left: 20px;" block href="#" v-b-toggle="'accordion' + index" variant="info">
                  {{getQuestionName(element.question, index)}}
                </b-button>
              </b-card-header>
              <b-collapse :id="'accordion' + index" accordion="question-accordion" role="tabpanel">
                <b-card-body>
                  <b-row>
                    <b-col>
                      <h5>{{ $t('privatePage.scale') }}</h5>
                      {{element.scaleName}}
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <display-module-bp v-if="questionFormat(1)"
                        :question="element.question">
                      </display-module-bp>
                      <display-module-gverb v-else-if="questionFormat(2)"
                        :question="element.question">
                      </display-module-gverb>
                      <display-module-gnum v-else-if="questionFormat(3)"
                        :question="element.question">
                      </display-module-gnum>
                      <display-module-gfair v-else-if="questionFormat(4)"
                        :question="element.question">
                      </display-module-gfair>
                      <display-module-gfig v-else-if="questionFormat(5)"
                        :question="element.question">
                      </display-module-gfig>
                      <display-module-ledord v-else-if="questionFormat(8)"
                        :question="element.question">
                      </display-module-ledord>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </template>
      </draggable>
      <b-row>
        <b-col>
          <b-form-group>
              <b-button variant="primary" class="me-1" @click="saveQuestionsOrder">{{ $t('save') }}</b-button>
              <b-button variant="warning" @click="randomizeQuestionOrder">{{ $t('privatePage.testmethod_randomize') }}</b-button>
            </b-form-group>
          </b-col>
      </b-row>
    </b-col>
  </b-form>

</template>

<script>
import draggable from 'vuedraggable'
import editorFuncs from '../../scales/questions/questioneditorfuncs'
import DisplayModuleBp from './displaymodules/displaymodulebp'
import DisplayModuleGverb from './displaymodules/displaymodulegverb'
import DisplayModuleGnum from './displaymodules/displaymodulegnum'
import DisplayModuleGfair from './displaymodules/displaymodulegfair'
import DisplayModuleGfig from './displaymodules/displaymodulegfig'
import DisplayModuleLedord from './displaymodules/displaymoduleledord'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'test-method-questions-order-editor',
  components: { draggable, DisplayModuleBp, DisplayModuleGfair, DisplayModuleGfig, DisplayModuleGverb, DisplayModuleGnum, DisplayModuleLedord },
  props: {
    currentTestMethod: {}
  },
  computed: {
    ...mapGetters(['userId', 'selectedCulture'])
  },
  methods: {
    ...mapActions('testMethodsModule', {
      updateTestMethodQuestionsOrder: 'updateTestMethodQuestionsOrder'
    }),
    ...mapActions({
      showErrorMessage: 'showErrorMessage',
      showSuccessMessage: 'showSuccessMessage'
    }),
    questionFormat(format) {
      return format === this.currentTestMethod.questionFormatId
    },
    getQuestionName(question, index) {
      return editorFuncs.getTextQuestionName(question) !== null
        ? editorFuncs.getTextQuestionName(question)
        : this.$t('question') + ': ' + (index + 1)
    },
    onDeleteQuestion() {},
    saveQuestionsOrder() {
      let i
      var dictionary = {}

      for (i = 0; i < this.currentTestMethod.testMethodQuestions.length; i++) {
        dictionary[this.currentTestMethod.testMethodQuestions[i].question.id] = i
      }

      this.updateTestMethodQuestionsOrder({
        testMethodId: this.currentTestMethod.id,
        postData: {questionOrderDictionary: dictionary, selectedLanguageId: this.selectedCulture.languageId, userId: this.userId}
      })
        .then(() => {
          this.showSuccessMessage(this.$t('save_ok_feedback'))
        })
        .catch(error => {
          this.showErrorMessage(error)
        })
    },
    randomizeQuestionOrder() {
      let ctr = this.currentTestMethod.testMethodQuestions.length
      let temp
      let index

      while (ctr > 0) {
        index = Math.floor(Math.random() * ctr)
        ctr--
        temp = this.currentTestMethod.testMethodQuestions[ctr]
        this.currentTestMethod.testMethodQuestions[ctr] = this.currentTestMethod.testMethodQuestions[index]
        this.currentTestMethod.testMethodQuestions[index] = temp
      }
    }
  }
}
</script>
